// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('products/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/get/adminProducts', params)
  return response.data
})

export const addProduct = createAsyncThunk(
  'products/addProduct',
  async (params, { dispatch, getState }) => {
    await axios.post('https://api.fntpf.ir/add/adminProducts', params)
    await dispatch(getData(getState().permissions.params))
    return params
  }
)

export const updateProduct = createAsyncThunk(
  'products/updateProduct',
  async (params, { dispatch, getState }) => {
    await axios.post('https://api.fntpf.ir/add/adminProducts', params)
    await dispatch(getData(getState().permissions.params))
    return { id, name }
  }
)

export const deletePermission = createAsyncThunk('products/deletePermission', async (id, { dispatch, getState }) => {
  console.log('ID: ', id)
  await axios.post('https://api.fntpf.ir/delete/products', id)
  await dispatch(getData(getState().permissions.params))
  return id
})

export const permissionsSlice = createSlice({
  name: 'products',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selected: null
  },
  reducers: {
    selectPermission: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.total = action.payload.allData.length
      state.params = action.payload.params
      state.allData = action.payload.allData
    })
  }
})

export const { selectPermission } = permissionsSlice.actions

export default permissionsSlice.reducer
